import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSelect from "../../../../components/Select/Select";
import { getAppointmentsFacilityReportData } from "../../../../redux/reducers/reportSlice";
import { AppColors } from "../../../../util/AppColors";
import { w20h20BlueIcon } from "../../../../util/CommonIconStyle";
import { facilityTypes } from "../../../../util/dropList";
import ReportTable from "../ReportTable";
import { nameExpan } from "../tableHeaders";

const tableHdrs = [
  "facilityName",
  "facilityType",
  "totalAppointments",
  "averageDowntime",
  "utilizationTime",
  "utilizationPercentage",
];

const apntTableHdrs = [
  "date",
  "vetName",
  "caseId",
  "petName",
  "timeSpent",
  "status",
];

const filList = [
  { name: "Day", value: "day" },
  { name: "Week", value: "week" },
  { name: "Month", value: "month" },
  { name: "Quarter", value: "quarte" },
  { name: "Year", value: "year" },
];

const AppointmentsFacilityReport = () => {
  const dispatch = useDispatch();
  const [selectedFilter, setSelectedFilter] = useState(filList[0]);
  const [crntTblHeders, setCrntTblHeders] = useState(tableHdrs?.slice(0, 5));
  const [activeTableHeaders, setActiveTableHeaders] = useState(
    tableHdrs?.slice(0, 5)?.map((pd, i) => ({ name: pd, isSelected: true, i })),
  );
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const [apntPage, setApntPage] = useState(1);
  const [selectedRow, setSelectedRow] = useState(null);
  const { appoinmentFacility } = useSelector((state) => state?.report);
  const rowsPerPage = 10;

  useEffect(() => {
    onApiCall(1, selectedFilter);
  }, [dispatch, selectedFilter]);

  const onApiCall = (pge = 1, filter = null) => {
    setPage(pge);
    const reqFilter = filter
      ? (filter?.value ?? filter)
      : selectedFilter?.value;
    const reqObj = {
      type: "facility",
      page: pge,
      itemSize: rowsPerPage,
      filter: reqFilter,
    };
    dispatch(getAppointmentsFacilityReportData(reqObj));
  };

  const handleEditColumn = () => {
    const reqList = tableHdrs?.map((pd, i) => {
      const isObjMat = activeTableHeaders?.find(
        (tblHdr) => tblHdr?.name === pd,
      );
      return { name: pd, isSelected: isObjMat?.isSelected ?? false, i };
    });
    setActiveTableHeaders(reqList);
    setEditColModVsble(true);
  };

  const onEditModClose = () => {
    setEditColModVsble(false);
  };

  const handleSelcetdColumn = (selected, ind) => {
    const reqList = activeTableHeaders?.map((act, i) => {
      if (i === ind) return { ...act, isSelected: selected };
      return act;
    });
    setActiveTableHeaders(reqList);
  };

  const handleSaveTableColumn = () => {
    const reqList = activeTableHeaders
      ?.filter((act) => act?.isSelected)
      ?.map((act) => {
        return act?.name;
      });
    setCrntTblHeders(reqList);
    setEditColModVsble(false);
  };

  const totalPage = Math.ceil(
    (appoinmentFacility?.totalRecords ?? 0) / rowsPerPage,
  );

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const getTableData = () => {
    return (appoinmentFacility?.data ?? [])?.map((li) => {
      const facObj = li?.facility;
      const reqFac = facilityTypes?.find(
        (ft) => ft?.value === li?.facilityType,
      );
      const reqObj = {
        facilityId: facObj?.facilityId,
        facilityName: facObj?.facilityName,
        status: (facObj?.status ?? "")?.toString(),
        createdBy: facObj?.userName,
        totalAppointments: li?.appointmentDetails?.length ?? 0,
        utilizationPercentage: li?.utilizationPercentage,
        averageDowntime: li?.totalDowntimeHours,
        utilizationTime: li?.totalUtilizationHours,
      };
      return {
        ...reqObj,
        facilityType: (
          <div
            className="blue-color txt-semi-bold cursor"
            onClick={() => setSelectedRow(reqObj)}
          >
            {reqFac?.name ?? li?.facilityType}
          </div>
        ),
      };
    });
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  const getFacilityBasedAppointments = () => {
    if (!selectedRow?.facilityId) return;
    const reqList =
      (appoinmentFacility?.data ?? [])?.find(
        (li) => li?.facility?.facilityId === selectedRow?.facilityId,
      )?.appointmentDetails ?? [];
    return reqList;
  };

  const handleChangeApntPage = (e, selectedPage) => {
    setApntPage(selectedPage);
  };

  const getApntTableData = () => {
    return (getFacilityBasedAppointments() ?? [])
      ?.slice((apntPage - 1) * rowsPerPage, apntPage * rowsPerPage)
      ?.map((li) => ({
        ...li,
        date: `${moment(new Date(li?.appointmentDateTime)).format("DD MMM YYYY, HH:mm")}`,
      }));
  };

  const totalApntPage = Math.ceil(
    (getFacilityBasedAppointments()?.length ?? 0) / rowsPerPage,
  );

  return (
    <>
      {selectedRow ? (
        <div>
          <div
            className="flex-row-ali-cen cursor ml15"
            onClick={() => {
              setSelectedRow(null);
              setApntPage(1);
            }}
          >
            <ArrowBackIcon
              sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
            />
            <Typography className="fs16 txt-semi-bold blue-color ml5">
              Back
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt10 mh20">
            <Typography className="font-medium fs12 gray28 ml10">
              Number of Records: {getFacilityBasedAppointments()?.length ?? 0}
            </Typography>
          </div>
          <div className="mtMin10">
            <ReportTable datas={getApntTableData()} columns={apntTableHdrs} />
            <div className="flex1-end mtMin30">
              {Math.ceil(
                (getFacilityBasedAppointments()?.length ?? 0) / rowsPerPage,
              ) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex1-end">
                        <Pagination
                          count={totalApntPage}
                          variant="outlined"
                          color="primary"
                          page={apntPage}
                          onChange={handleChangeApntPage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex-row-ali-cen mt5 mh20">
            <Typography className="font-medium fs12 gray28 ml10">
              Number of Records: {appoinmentFacility?.totalRecords ?? 0}
            </Typography>
            <div
              className="flex-row-ali-cen ml20 cursor"
              onClick={handleEditColumn}
            >
              <EditOutlinedIcon sx={w20h20BlueIcon} />
              <Typography className="blue-color fs16 font-medium ml5">
                Edit columns ({crntTblHeders?.length})
              </Typography>
            </div>
            <div
              className="flex-row-ali-cen ml20 cursor"
              onClick={handleOpenChart}
            >
              <AutoGraphIcon sx={w20h20BlueIcon} />
            </div>
            <div className="flex1-end">
              <div className="w15Per">
                <CustomSelect
                  list={filList}
                  value={selectedFilter}
                  handleChange={(e, value) => setSelectedFilter(value)}
                  name="selectedFilter"
                  label=""
                  select
                  search
                />
              </div>
            </div>
          </div>
          <div className="mtMin10">
            <ReportTable
              datas={getTableData()?.map((li) => ({
                ...li,
                date: `${moment(new Date(li?.appointmentDate)).format("DD MMM YYYY")}, ${li?.appointmentTime}`,
              }))}
              columns={crntTblHeders}
            />
            <div className="flex1-end mtMin30">
              {Math.ceil(
                (appoinmentFacility?.totalRecords ?? 0) / rowsPerPage,
              ) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex1-end">
                        <Pagination
                          count={totalPage}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </div>
          </div>
        </div>
      )}

      <CustomModal
        open={editColModVsble}
        onClose={onEditModClose}
        header="Columns"
        modal
        modalWidth={25}
      >
        <div className="ph20 scroll-70vh">
          {activeTableHeaders?.map((hr) => (
            <div className="flex-row" key={hr?.i}>
              <CustomCheckbox
                label={nameExpan?.[hr?.name]}
                checked={hr?.isSelected}
                onChange={() => handleSelcetdColumn(!hr?.isSelected, hr?.i)}
              />
            </div>
          ))}
          <div className="flex-end mb10">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={handleSaveTableColumn}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default AppointmentsFacilityReport;
